import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

document.addEventListener("DOMContentLoaded", function () {
  const listContainer = document.getElementById("conversationList");
  if (!listContainer) return; // Only execute on messaging page

  let stompClient = null;

  function connect() {
    const socket = new SockJS("/ws", null, {
      transports: ["websocket"],
    });

    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      debug: (str) => console.log("[Messaging WebSocket]", str),
      onConnect: () => {
        console.log("[Messaging WebSocket] Connected");

        fetch("/api/user/current-location")
          .then((res) => res.json())
          .then((locId) => {
            stompClient.subscribe("/topic/messaging/" + locId, function (messageOutput) {
              const message = JSON.parse(messageOutput.body);
              if (window.appendIncomingMessage) {
                window.appendIncomingMessage(message);
              }
            });
            stompClient.subscribe("/topic/messaging-status/" + locId, function (messageOutput) {
              const statusUpdate = JSON.parse(messageOutput.body);
              if (window.updateMessageStatus) {
                window.updateMessageStatus(statusUpdate);
              }
            });
            stompClient.subscribe(`/topic/messaging-id-update/${locationId}`, function (message) {
              const update = JSON.parse(message.body);
              const msgDiv = document.querySelector(
                `div[data-message-id="${update.oldExternalMessageId}"]`,
              );
              if (msgDiv) {
                msgDiv.setAttribute("data-message-id", update.newExternalMessageId);
              }
            });
          })
          .catch(() => {
            // Fallback to a hardcoded 0 or try to parse from the select in sidenav
            const sel = document.getElementById("standort");
            if (sel) {
              const locId = sel.value;
              stompClient.subscribe("/topic/messaging/" + locId, function (messageOutput) {
                const message = JSON.parse(messageOutput.body);
                if (window.appendIncomingMessage) {
                  window.appendIncomingMessage(message);
                }
              });
              stompClient.subscribe("/topic/messaging-status/" + locId, function (messageOutput) {
                const statusUpdate = JSON.parse(messageOutput.body);
                if (window.updateMessageStatus) {
                  window.updateMessageStatus(statusUpdate);
                }
              });
            }
          });
      },
      onStompError: (frame) => {
        console.error("[Messaging WebSocket] STOMP Protocol Error: " + frame.headers["message"]);
      },
      onWebSocketError: (event) => {
        console.error("[Messaging WebSocket] WebSocket Error:", event);
      },
    });

    stompClient.activate();
  }

  connect();
});
